import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSettingsStore = defineStore('settings', () => {
	const convention = ref('Pièce n°{numero} - {nom}');

	const setConvention = (value: string) => {
		convention.value = value;
		localStorage.setItem('pappers-addon-convention', value);
	};

	const loadConvention = () => {
		const saved = localStorage.getItem('pappers-addon-convention');
		if (saved) convention.value = saved;
	};

	const formatPiece = (numero: number, nom: string, date: string | null): string => {
		return convention.value
			.replace('{numero}', String(numero))
			.replace('{nom}', nom)
			.replace('{date}', date || '');
	};

	return {
		convention,
		setConvention,
		loadConvention,
		formatPiece
	};
});
